// Milliseconds → compact duration for the standing check "Selected Sit / Stand Time"
// columns (feature 087). The column is VARCHAR and stored exactly as the app sent it.
//
// Rounded to the nearest whole second, then: largest non-zero unit first, zero middle
// units kept, zero trailing units dropped — 45000 → "45s", 90000 → "1m 30s",
// 120000 → "2m", 3605000 → "1h 0m 5s", 0 → "0s". Empty → "-" (older app builds send
// neither field). Anything that is not a non-negative number is shown verbatim, so a
// bad value is visible, not hidden.
//
// @param {string|number|null|undefined} value  milliseconds
// @returns {string}
export function formatDurationMs(value) {
  if (value === null || value === undefined || value === '') return '-';
  const text = String(value).trim();
  if (!/^\d+(\.\d+)?$/.test(text)) return text;

  const total = Math.round(Number(text) / 1000);
  const parts = [
    [Math.floor(total / 3600), 'h'],
    [Math.floor((total % 3600) / 60), 'm'],
    [total % 60, 's'],
  ];
  const first = parts.findIndex(([n]) => n > 0);
  if (first === -1) return '0s';
  let last = parts.length - 1;
  while (parts[last][0] === 0) last -= 1;
  return parts.slice(first, last + 1).map(([n, unit]) => `${n}${unit}`).join(' ');
}
